<div class="flex flex-col items-center gap-6 md:flex-row md:items-start">
  <div class="flex w-full flex-col gap-4 md:w-2/3">
    <div
      class="flex flex-col gap-5 rounded-2xl border p-8"
      [ngStyle]="{
        borderColor: corporateDesign.primaryBorderColor(),
        backgroundColor: corporateDesign.surface1(),
        color: corporateDesign.isDarkModeActive()
          ? corporateDesign.corporateDesign().primaryDarkFontColor
          : corporateDesign.corporateDesign().colorAdmixtures
              .standard_text_high,
      }">
      <h2 class="text-2xl font-bold">
        {{
          textStore.texts()
            | filterTexts
              : ERelationType.actualTimes
              : EEntityType.onDemandTicketConfiguration
            | language
        }}
      </h2>

      @if (journeyDisplay.hasAnyDeviation()) {
        <div
          class="flex flex-row items-start gap-2 rounded-xl p-4 text-base"
          [ngStyle]="{
            backgroundColor: corporateDesign.isDarkModeActive()
              ? corporateDesign.corporateDesign().secondaryColor + '20'
              : corporateDesign.corporateDesign().secondaryColor + '30',
            color: corporateDesign.isDarkModeActive()
              ? corporateDesign.corporateDesign().secondaryColor
              : corporateDesign.corporateDesign().secondaryBorderColor,
          }">
          <span
            class="material-symbols-rounded"
            [ngStyle]="{
              color: corporateDesign.isDarkModeActive()
                ? corporateDesign.corporateDesign().secondaryColor
                : corporateDesign.corporateDesign().secondaryColor,
            }"
            >warning</span
          >
          <span>{{
            textStore.texts()
              | filterTexts
                : ERelationType.deviationWarning
                : EEntityType.onDemandTicketConfiguration
              | language
          }}</span>
        </div>
      }

      <aw-on-demand-journey-timeline />
    </div>
  </div>

  <aw-on-demand-ticket-configuration-summary [showReservationDeadline]="true">
    <aw-button
      summary-action
      id="on-demand-reservation-next"
      type="button"
      [style]="'error'"
      (click)="navigateNext()">
      {{
        textStore.texts()
          | filterTexts
            : ERelationType.next
            : EEntityType.onDemandTicketConfiguration
          | language
      }}
    </aw-button>
  </aw-on-demand-ticket-configuration-summary>
</div>
